import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ArrowRightContained02 = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M13.2391 7.54239C12.9739 7.22418 12.501 7.18118 12.1828 7.44636C11.8646 7.71153 11.8216 8.18445 12.0868 8.50266L13.2391 7.54239ZM15.9775 12L16.5537 12.4802C16.7855 12.202 16.7855 11.798 16.5537 11.5199L15.9775 12ZM12.0868 15.4974C11.8216 15.8156 11.8646 16.2885 12.1828 16.5537C12.501 16.8189 12.9739 16.7759 13.2391 16.4577L12.0868 15.4974ZM8.02253 11.25C7.60831 11.25 7.27253 11.5858 7.27253 12C7.27253 12.4142 7.60831 12.75 8.02253 12.75L8.02253 11.25ZM12.0868 8.50266L15.4014 12.4802L16.5537 11.5199L13.2391 7.54239L12.0868 8.50266ZM15.4014 11.5199L12.0868 15.4974L13.2391 16.4577L16.5537 12.4802L15.4014 11.5199ZM15.9775 11.25L8.02253 11.25L8.02253 12.75L15.9775 12.75V11.25ZM17.8336 6.16637C21.0555 9.38819 21.0555 14.6118 17.8336 17.8336L18.8943 18.8943C22.7019 15.0867 22.7019 8.91332 18.8943 5.10571L17.8336 6.16637ZM17.8336 17.8336C14.6118 21.0555 9.38819 21.0555 6.16637 17.8336L5.10571 18.8943C8.91332 22.7019 15.0867 22.7019 18.8943 18.8943L17.8336 17.8336ZM6.16637 17.8336C2.94454 14.6118 2.94454 9.38819 6.16637 6.16637L5.10571 5.10571C1.2981 8.91332 1.2981 15.0867 5.10571 18.8943L6.16637 17.8336ZM6.16637 6.16637C9.38819 2.94454 14.6118 2.94454 17.8336 6.16637L18.8943 5.10571C15.0867 1.2981 8.91332 1.2981 5.10571 5.10571L6.16637 6.16637Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ArrowRightContained02
